import { computed, defineComponent, toRefs } from '@vue/composition-api';
import sanitizeHtml from 'sanitize-html';
export default defineComponent({
    name: 'DpSafeHtml',
    props: {
        html: { type: String, default: '' },
    },
    setup(props) {
        const { html } = toRefs(props);
        const safeHtml = computed(() => {
            const input = html.value;
            return sanitizeHtml(input, {
                allowedTags: ['p', 'span', 'b', 'strong', 'br', 'a'],
                allowedAttributes: {
                    span: ['style'],
                },
            });
        });
        return {
            safeHtml,
        };
    },
});
